import { twMerge } from 'tailwind-merge';

import { getIconUrlSelector, useConfigStore } from '@packages/stores';

import { Text, TextProps } from '@elements/text';
import { TextWithMd } from '@elements/text/textWithMd';
import { useBoostDetailsStore } from '@store';
import { sluggify, testProps } from '@utils';

export interface BenefitsProps {
  Icon?: React.FC<React.SVGProps<SVGElement>> | string;
  title?: TextProps;
  subTitle?: TextProps;
  description?: TextProps;
}

export const BenefitsItem: React.FC<BenefitsProps> = () => {
  const inclusions =
    useBoostDetailsStore(state => state.mandatoryBoostDetails?.template?.inclusions) ?? [];
  const iconUrl = useConfigStore(getIconUrlSelector);
  return (
    <>
      {inclusions.map((item, index) => (
        <div
          className={twMerge(
            'border-b grid grid-cols-[3.75rem_1fr] md:grid-cols-[5rem_1fr] py-5 first:pt-0',
            inclusions.length - 1 === index && 'border-b-0',
          )}
          key={item.title}>
          <div className="order">
            {item.iconPath && typeof item.iconPath === 'string' && (
              <img src={iconUrl(item.iconPath)} className="h-12 w-12 md:h-16 md:w-16" />
            )}
          </div>
          <div>
            <div className="flex justify-between pb-4 md:pb-2">
              <TextWithMd variant="body-16/sb" {...testProps(sluggify(item.title))}>
                {item.title}
              </TextWithMd>
              <Text
                className="text-right"
                variant="body-16/sb"
                {...testProps(sluggify(`${item.title}-amount`))}>
                {item.subTitle}
              </Text>
            </div>
            <TextWithMd
              className="text-fuji-800-300"
              variant="subHeading-14/r"
              {...testProps(`${sluggify(item.title)}-description`)}>
              {item.description}
            </TextWithMd>
          </div>
        </div>
      ))}
    </>
  );
};
